import { AlertsPage } from "pages/AlertsPage";
import CaseManagementPage from "pages/CaseManagementPage";
import DownDerateTrackerPage from "pages/DownDerateTrackerPage";
import { DataExplorationPageV2 } from "pages/DataExplorationPageV2";
import { FleetManagerPage } from "pages/FleetManagerPage";
import { SettingsPage } from "pages/settings/SettingsPage";
import { MyActionsPage } from "pages/MyActionsPage";
import { SysInfoPage } from "pages/settings/SysInfoPage";
import { ActiveIssues } from "components/ActiveIssues/ActiveIssues";
import { FleetRoutes } from "./FleetRoutes";
import { UserManagementPage } from "pages/Users/UserManagementPage";

import {
  Assignment,
  Dashboard,
  Explore,
  ImportExport,
  Notifications,
  People,
  PlaylistAddCheck,
  Public,
  Settings,
  SettingsSystemDaydream,
  TrendingDown,
  Folder,
  Timeline
} from "@mui/icons-material";
import { ProjectsPage } from "pages/Projects/ProjectsPage";
import { KpisPage } from "pages/Kpis/KpisPage";

export const fleetRoute = {
  path: "/fleet",
  name: "Overview",
  icon: Public,
  component: FleetRoutes,
  layout: "/pages"
};

export const myActionsRoute = {
  path: "/my-actions",
  name: "My Actions",
  icon: PlaylistAddCheck,
  component: MyActionsPage,
  layout: "/pages"
};

export const alertsRoute = {
  path: "/alerts",
  name: "Alerts",
  icon: Notifications,
  component: AlertsPage,
  layout: "/pages"
};

export const caseManagmementRoute = {
  path: "/case-management",
  name: "Case Management",
  icon: Assignment,
  component: CaseManagementPage,
  layout: "/pages"
};

export const fleetManagerRoute = {
  path: "/fleet-manager",
  name: "Fleet Manager",
  icon: Dashboard,
  component: FleetManagerPage,
  layout: "/pages"
};

export const downDerateTrackerRoute = {
  path: "/down-derate-tracker",
  name: "Down/Derated Tracker",
  icon: ImportExport,
  component: DownDerateTrackerPage,
  layout: "/pages"
};

export const dataExplorationRouteV2 = {
  path: "/data-exploration",
  name: "Data Exploration",
  icon: Explore,
  component: DataExplorationPageV2,
  layout: "/pages"
};

export const settingsRoute = {
  path: "/settings",
  name: "Settings",
  icon: Settings,
  component: SettingsPage,
  layout: "/pages"
};

export const sysInfoRoute = {
  path: "/sys-info",
  name: "Sys Info",
  icon: SettingsSystemDaydream,
  component: SysInfoPage,
  layout: "/pages"
};

export const lostEnergyRoute = {
  path: "/lost-energy/issue-tracking",
  name: "Lost Energy",
  icon: TrendingDown,
  component: ActiveIssues,
  layout: "/pages"
};

export const userManagementRoute = {
  path: "/users",
  name: "Users",
  icon: People,
  component: UserManagementPage,
  layout: "/pages"
};

export const projectsRoute = {
  path: "/projects",
  name: "Projects",
  icon: Folder,
  component: ProjectsPage,
  layout: "/pages"
};

export const kpisRoute = {
  path: "/kpis",
  name: "KPIs",
  icon: Timeline,
  component: KpisPage,
  layout: "/pages"
};
